export const painPoints: string[] = [
  'Recordás el punto de memoria pero no podés mostrárselo visualmente al paciente mientras lo tratás',
  'Perdés tiempo buscando en libros técnicos de 400 páginas durante o entre sesiones',
  'Tenés el conocimiento pero no una herramienta de consulta rápida que respalde tu criterio',
  'Tus pacientes no entienden qué punto les estás trabajando, por qué ni qué esperar',
  'No tenés un recurso para que el paciente identifique y trabaje el punto en casa entre sesiones',
  'Cada sesión depende de tu memoria en lugar de un sistema visual de respaldo preciso',
  'No contás con material para mostrar los meridianos de forma elegante y clínica frente al paciente',
  'Improvisás la combinación de puntos porque no tenés protocolos maestros por patología a mano',
  'Tus sesiones son efectivas pero no tienen la presentación profesional y premium que merecen',
  'Cada diagnóstico diferencial arranca desde cero sin un sistema visual de referencia rápida',
  'No podés explicar la diferencia entre tonificar y dispersar con una imagen que el paciente entienda',
  'Cuando combinás técnicas (aguja, moxa, digitopuntura) no tenés un sistema que las integre visualmente',
]
